import { LoaderWithInterestingFactsAboutAITranslations } from '@/assets/locales/components/loaderWithInterestingFactsAboutAI/loaderWithInterestingFactsAboutAI.translations.en';

export const loaderWithInterestingFactsAboutAITranslations: LoaderWithInterestingFactsAboutAITranslations =
  {
    content: {
      leadingText: 'AI pracuje, aby dostarczyć Ci najlepsze wyniki!',
      loaderDynamicInfo: {
        text1:
          'Czy wiesz, że pierwsze próby stworzenia sztucznej inteligencji miały miejsce już w latach 50. XX wieku?',
        text10:
          'Czy wiesz, że AI potrafi generować przepisy kulinarne na podstawie składników, które wprowadzisz do systemu?',
        text11:
          'Czy wiesz, że AI już potrafi rozpoznać gatunki roślin na podstawie zdjęć zrobionych przez użytkowników?',
        text12:
          'Czy wiesz, że AI analizuje dane z teleskopów, aby pomóc astronomom w odkrywaniu nowych planet?',
        text13:
          'Czy wiesz, że AI wspomaga prace redakcyjne w wydawnictwach książkowych, sugerując poprawki i ulepszenia w manuskryptach?',
        text14:
          'Czy wiesz, że AI pomaga w komponowaniu muzyki filmowej, analizując scenariusze i emocje przedstawione w scenach?',
        text15:
          'Czy wiesz, że AI jest wykorzystywane do optymalizacji strategii gry w pokera, ucząc się od najlepszych graczy?',
        text16:
          'Czy wiesz, że AI wspiera projektowanie wnętrz, analizując preferencje estetyczne użytkowników i proponując indywidualnie dostosowane rozwiązania?',
        text17: 'Czy wiesz, że AI potrafi generować wirtualne projekty ubrań?',
        text18:
          'Czy wiesz, że AI potrafi analizować twoje nawyki czytelnicze, aby rekomendować książki, które najprawdopodobniej ci się spodobają?',
        text19:
          'Czy wiesz, że istnieje AI, które potrafi symulować starożytne bitwy, analizując historyczne dane i strategie?',
        text2:
          'Czy wiesz, że istnieją algorytmy AI, które potrafią prognozować pogodę z większą dokładnością niż tradycyjne metody?',
        text20:
          'Czy wiesz, że AI już potrafi komponować utwory muzyczne w stylach historycznych kompozytorów, jak Mozart czy Beethoven?',
        text21:
          'Czy wiesz, że sztuczna inteligencja jest wykorzystywana do tworzenia realistycznych symulacji ekosystemów, pomagając naukowcom zrozumieć skutki zmian klimatycznych?',
        text22:
          'Czy wiesz, że AI potrafi identyfikować i klasyfikować różne gatunki ptaków na podstawie ich śpiewu, pomagając badaczom w monitorowaniu populacji dzikiej przyrody?',
        text3:
          'Czy wiesz, że w Japonii AI zostało wykorzystane do napisania noweli, która była bliska wygrania literackiego konkursu?',
        text4:
          'Czy wiesz, że sztuczna inteligencja pomaga archeologom w odkrywaniu nieznanych dotąd lokalizacji historycznych poprzez analizę zdjęć satelitarnych?',
        text5:
          'Czy wiesz, że AI potrafi samodzielnie nauczyć się gry w szachy i pokonać mistrzów światowego formatu?',
        text6:
          'Czy wiesz, że AI pomaga w treningu sportowców poprzez analizę ich techniki i sugestie optymalizacji ruchów?',
        text7:
          'Czy wiesz, że AI potrafi nauczyć się języka obcego, analizując tylko teksty w tym języku?',
        text8:
          'Czy wiesz, że istnieje AI, które potrafi analizować obrazy medyczne i z równą skutecznością co lekarze wykrywać choroby?',
        text9:
          'Czy wiesz, że sztuczna inteligencja może symulować rozmowy z historycznymi postaciami, używając tylko zapisów ich wypowiedzi?',
      },
    },
  };
